import React from 'react';
import { FEATURES } from '../../config/features';
import CardContactButton from './CardContactButton';

/**
 * A/B arm "card_button": a slim strip rendered directly under each result card
 * (works for ResultCard, FlightMultiResultCard and FlightTrainResultCard alike).
 * One row on every screen size; the helper text shortens on narrow phones.
 */
const CardContactStrip = ({ onClick }) => {
    if (!FEATURES.ENABLE_CONTACT_FORM) return null;
    return (
        <div
            className="mt-2 flex items-center justify-between gap-3 rounded-xl border border-orange-100
                       bg-orange-50/70 px-3 py-2 sm:px-4"
        >
            <p className="min-w-0 text-[13px] sm:text-sm text-slate-700 leading-snug">
                <span className="font-medium">Not getting a confirmed seat?</span>
                <span className="hidden sm:inline text-slate-500"> Our travel team can help.</span>
            </p>
            <CardContactButton onClick={onClick} className="shrink-0" />
        </div>
    );
};

export default CardContactStrip;
